export default __webpack_public_path__ + "static/media/meslaymini.2941c22a.jpg";